/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

export const SearchFieldWrapper = styled.div<{ width?: string }>`
  width: ${({ width }) => width || '184px'};
  ${media.upToMedium(`
    width: 100%;
  `)}

  ${media.upToSmall(`
    margin-top: ${token('space.100')};
  `)}
`;

export const SearchIconWrapper = styled.div`
  display: flex;
  margin-right: 6px;
`;

export const ClearFilterButton = styled(Button)`
  margin-right: 6px;
`;

export const SearchFieldAligner = styled.div`
  margin-bottom: ${token('space.150')};
  margin-right: ${token('space.100')};
  ${media.upToMedium(`
    width: 100%;
    margin-right: 0;
  `)}
`;
